<script>
export let team_instance;


import download from 'downloadjs';

import { auth } from 'store/index.js';

import { get } from 'svelte/store';


import tippy from 'sveltejs-tippy';



const export_contacts_props = {
	content: 'Export Contacts to File',
	placement: 'bottom',
	arrow: false,
}


const export_emails_props = {
	content: 'Export Emails to File',
	placement: 'bottom',
	arrow: false,
};

const export_roster_props = {
	content: 'Export Roster to File',
	placement: 'bottom',
	arrow: false,
};



const api_url = app_.env.API_URL;

let token = get(auth).token;


let contacts_loading = false;
let emails_loading = false;
let roster_loading = false;



async function exportContacts() {

	contacts_loading = true;

	const url = `${api_url}coaches/team-instance/${team_instance.id}/export/contacts`;

	const resp = await fetch(url, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.blob();

	contacts_loading = false;

	if (!resp.ok) {
		alert('Error fetching contacts file!');
		throw new Error(result.detail);
	}


	download(result, 'contacts.xlsx', 'xlsx');

}



async function exportEmails() {

	emails_loading = true;

	const url = `${api_url}coaches/team-instance/${team_instance.id}/export/emails`;

	const resp = await fetch(url, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.blob();

	emails_loading = false;

	// console.log(result);

	if (!resp.ok) {
		alert('Error fetching emails file!');
		throw new Error(result.detail);
	}


	download(result, 'my_mails.csv', 'text/csv');


	// return result;

}


async function exportRoster() {

	roster_loading = true;

	const url = `${api_url}coaches/team-instance/${team_instance.id}/export/roster`;

	const resp = await fetch(url, {
		method: 'GET',
		headers: {
			Authorization: `Bearer ${token}`,
		},
	});

	const result = await resp.blob();

	roster_loading = false;

	if (!resp.ok) {
		alert('Error fetching roster file!');
		throw new Error(result.detail);
	}


	download(result, 'my_roster.xlsx', 'xlsx');


	// return result; ... ?

}



</script>



<style>


</style>



<div class="tabs is-toggle" id="">

	<ul>

		<li>
			<a on:click={exportContacts} use:tippy={export_contacts_props}>
				Contacts
				<i class="far fa-file-export" class:is-hidden={contacts_loading}></i>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!contacts_loading}></i>
			</a>
		</li>

		<!-- <li>
			<a on:click={exportEmails} use:tippy={export_emails_props}>
				Emails
				<i class="far fa-file-export" class:is-hidden={emails_loading}></i>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!emails_loading}></i>
			</a>
		</li> -->

		<li>
			<a on:click={exportRoster} use:tippy={export_roster_props}>
				Roster
				<i class="far fa-file-export" class:is-hidden={roster_loading}></i>
				<i class="fas fa-circle-notch fa-spin" class:is-hidden={!roster_loading}></i>
			</a>
		</li>

	</ul>

</div>




